import {
  cloud as CommercialIcon,
  file as GenericIcon,
  file_contract as RegulatoryIcon,
  file_signing as ContractIcon,
  news as EventsIcon,
  office_buildings as InternalIcon,
  people_1 as TeamIcon,
  widget_android as AppIcon,
} from '@dnb/eufemia/icons';

import type { NavNodeType } from './types';

/**
 * Get the appropriate icon for a navigation node type
 *
 * @param type - The type of navigation node (team, app, api, or generic)
 * @returns The corresponding DNB Eufemia icon component
 */
export function getIconForType(type: NavNodeType) {
  switch (type) {
    case 'team': {
      return TeamIcon;
    }
    case 'app': {
      return AppIcon;
    }
    case 'events': {
      return EventsIcon;
    }
    case 'regulatory': {
      return RegulatoryIcon;
    }
    case 'commercial': {
      return CommercialIcon;
    }
    case 'internal': {
      return InternalIcon;
    }
    case 'contract': {
      return ContractIcon;
    }
    default: {
      return GenericIcon;
    }
  }
}
